import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconTwinkleLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.813 1.821C19.38.726 17.83.726 17.4 1.821l-.67 1.697-1.696.67c-1.095.431-1.095 1.98 0 2.413l1.696.669.67 1.696c.431 1.095 1.981 1.095 2.413 0l.67-1.696 1.696-.67c1.095-.431 1.095-1.981 0-2.413l-1.697-.67-.67-1.696Zm-1.876 2.173.67-1.697.668 1.697c.132.334.397.599.731.73l1.697.67-1.697.669a1.297 1.297 0 0 0-.73.73l-.67 1.697-.669-1.696a1.297 1.297 0 0 0-.73-.731l-1.698-.67 1.697-.668c.335-.132.6-.397.731-.731Zm-5.19 1.8c-.573-1.451-2.626-1.451-3.199 0L8.04 9.617a.227.227 0 0 1-.128.127l-3.824 1.509c-1.45.572-1.45 2.625 0 3.197l3.824 1.509c.059.023.105.07.128.128l1.508 3.824c.573 1.45 2.626 1.45 3.198 0l1.508-3.824a.227.227 0 0 1 .128-.128l3.825-1.509c1.45-.572 1.45-2.625 0-3.197l-3.825-1.509a.227.227 0 0 1-.127-.127l-1.509-3.825Zm-1.81.547a.227.227 0 0 1 .421 0l1.509 3.824c.174.443.525.794.968.968l3.824 1.508a.227.227 0 0 1 0 .423l-3.824 1.508a1.719 1.719 0 0 0-.968.968l-1.509 3.825a.227.227 0 0 1-.422 0L9.428 15.54a1.719 1.719 0 0 0-.968-.968l-3.825-1.508a.227.227 0 0 1 0-.423l3.825-1.508c.443-.174.793-.525.968-.968l1.508-3.824Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={fill}
      />
    </Svg>
  );
};

export default IconTwinkleLine;
